import { useTranslation } from 'react-i18next';
import { useCheckbox } from 'src/components/Checkbox';

type ReturnType = {
  checked: boolean;
  PaymentAgree: JSX.Element;
};

export const usePaymentAgree = (): ReturnType => {
  const { t } = useTranslation();
  const { checked, CustomCheckbox } = useCheckbox({
    name: 'agreement',
    component: <label className="N_14_R text-greyish-brown ml-3 self-start">{t('payment/agreement_subscription_content')}</label>,
  });
  return {
    checked,
    PaymentAgree: (
      <div className="py-8 border-t border-ice-blue">
        <div className="container">
          <div className="N_16_M text-black">{t('payment/purchase_agreement_title')}</div>
          <div className="mt-3 flex items-start">{CustomCheckbox}</div>
        </div>
      </div>
    ),
  };
};
